export default __webpack_public_path__ + "static/media/speaker-2.90600bb4.png";